import statuses from "@/pages/Course/components/CoursePackages/helpers/statuses";
export default statuses;
